import React from 'react';
import { Navigate, type NavigateProps } from '@common/components';
import { useLocation, useParams } from '@common/hooks';

export function AppendNavigate({
  append,
  ...props
}: Omit<NavigateProps, 'to'> & { append: string }) {
  const { pathname } = useLocation();

  return <Navigate {...props} to={`${pathname}/${append}`} replace />;
}

export function NavigateParsedParams({ to, ...props }: NavigateProps) {
  const params = useParams();
  const paramKeys = Object.keys(params);
  const isToString = typeof to === 'string';

  if (!isToString) {
    return <Navigate {...props} to={to} replace />;
  }

  const parsedTo = paramKeys.reduce(
    (acc, paramKey) => acc.replace(`:${paramKey}`, params[paramKey] || ''),
    to
  );

  return <Navigate {...props} to={parsedTo} replace />;
}

export function NavigateWildCard({ to, ...props }: NavigateProps) {
  const { '*': wildcard } = useParams();
  const finalTo = applyWildCard(to, wildcard);

  return <Navigate {...props} to={finalTo} replace />;
}

function applyWildCard(to: NavigateProps['to'], wildcard?: string) {
  const isToString = typeof to === 'string';
  return isToString ? to.replace('*', wildcard || '') : to;
}
